import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-75f4fa8e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "step-one"
};
var _hoisted_2 = {
  class: "one-top"
};
var _hoisted_3 = {
  class: "video-area"
};
var _hoisted_4 = {
  class: "video-status-box"
};
var _hoisted_5 = {
  key: 0,
  class: "video-status"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "camera-close"
  }, null, -1);
});
var _hoisted_7 = {
  key: 0,
  class: "status-txt"
};
var _hoisted_8 = {
  key: 1,
  class: "status-txt"
};
var _hoisted_9 = {
  class: "device-area"
};
var _hoisted_10 = {
  class: "device-list"
};
var _hoisted_11 = {
  class: "device-item"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "name"
  }, "录制格式", -1);
});
var _hoisted_13 = {
  key: 0,
  class: "txt"
};
var _hoisted_14 = {
  key: 1,
  class: "txt"
};
var _hoisted_15 = {
  class: "device-item"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "name"
  }, "窗口分享", -1);
});
var _hoisted_17 = {
  key: 0,
  class: "txt"
};
var _hoisted_18 = {
  key: 1,
  class: "txt"
};
var _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"check-tips\" data-v-75f4fa8e><div class=\"tips-title\" data-v-75f4fa8e><span class=\"line\" data-v-75f4fa8e></span><span class=\"title\" data-v-75f4fa8e>注意事项</span><span class=\"line\" data-v-75f4fa8e></span></div><div class=\"row-tips\" data-v-75f4fa8e><div class=\"col-tips\" data-v-75f4fa8e><div class=\"col-title\" data-v-75f4fa8e><span class=\"index\" data-v-75f4fa8e>1.</span><p data-v-75f4fa8e> 点击 <span class=\"orange-block\" data-v-75f4fa8e>分享窗口</span> 后，浏览器提示您授权，请务必点击 <span class=\"orange\" data-v-75f4fa8e>窗口页面</span> ，选择浏览器对应的窗口,再点击分享。 </p></div><div class=\"col-img\" data-v-75f4fa8e><img class=\"img1\" src=\"https://img.pipabiancheng.com/assets/ug-fe-contest/20250408/guide-gif.gif\" alt=\"\" data-v-75f4fa8e></div></div><div class=\"col-tips\" data-v-75f4fa8e><div class=\"col-title\" data-v-75f4fa8e><span class=\"index\" data-v-75f4fa8e>2.</span><p data-v-75f4fa8e> 如果<span class=\"orange\" data-v-75f4fa8e>窗口页面</span>显示打开系统偏好设置, 请进行对应操作后,再重新进入录制视频。 </p></div><div class=\"col-img\" data-v-75f4fa8e><img src=\"https://img.pipabiancheng.com/assets/ug-fe-contest/20250408/permission-guide.png\" alt=\"\" class=\"img2\" data-v-75f4fa8e></div></div></div></div>", 1);
import { computed, watch, ref, onMounted } from 'vue';
import { ScreenMediaService } from '@/services/recordVideo/media.service';
import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import { useService } from '@kaokei/use-vue-service';
import { debounce } from 'lodash-es';
export default /*#__PURE__*/_defineComponent({
  emits: ['update-step'],
  setup: function (__props, _a) {
    var _this = this;
    var emit = _a.emit;
    var screenMediaService = useService(ScreenMediaService);
    var recordVideoService = useService(RecordVideoService);
    var DeviceState = computed(function () {
      return screenMediaService.DeviceState;
    });
    var microVideoRef = ref();
    var nextStepLoading = ref(false);
    var checkStart = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              nextStepLoading.value = true;
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              return [4 /*yield*/, screenMediaService.checkStartScreen()];
            case 2:
              _a.sent();
              nextStepLoading.value = false;
              return [3 /*break*/, 4];
            case 3:
              e_1 = _a.sent();
              nextStepLoading.value = false;
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    var JudgeCheckSuccess = computed(function () {
      return DeviceState.value.screen.status === 'finish' && DeviceState.value.recordType.status === 'finish';
    });
    var JudgeCheckError = computed(function () {
      return DeviceState.value.screen.status === 'error' || DeviceState.value.recordType.status === 'error';
    });
    var onNextStep = debounce(function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (JudgeCheckSuccess.value) {
            nextStepLoading.value = true;
            recordVideoService.goStep(1);
          } else {
            checkStart();
          }
          return [2 /*return*/];
        });
      });
    }, 240);
    var noAuthEntrance = function () {
      recordVideoService.hideRecordCom();
      recordVideoService.showVideoUpload();
      screenMediaService.initCheckState();
      screenMediaService.dispose();
    };
    onMounted(function () {
      watch(function () {
        return screenMediaService.screenStream;
      }, function (newStream) {
        if (microVideoRef.value) {
          microVideoRef.value.srcObject = newStream;
        }
      }, {
        immediate: true
      });
    });
    return function (_ctx, _cache) {
      var _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("video", {
        class: "video-box",
        ref: function (_value, _refs) {
          _refs['microVideoRef'] = _value;
          microVideoRef.value = _value;
        },
        autoplay: "",
        playsinline: "",
        muted: ""
      }, null, 512), !_unref(screenMediaService).screenStream ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _unref(DeviceState).camera.status === 'wait' ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 未进行窗口分享 ")) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(DeviceState).camera.txt), 1))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("ul", _hoisted_10, [_createElementVNode("li", _hoisted_11, [_createElementVNode("span", {
        class: _normalizeClass(["status", ["status-".concat(_unref(DeviceState).recordType.status)]])
      }, null, 2), _hoisted_12, _unref(DeviceState).recordType.status === 'process' ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 格式检测中... ")) : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(DeviceState).recordType.txt), 1))]), _createElementVNode("li", _hoisted_15, [_createElementVNode("span", {
        class: _normalizeClass(["status", ["status-".concat(_unref(DeviceState).screen.status)]])
      }, null, 2), _hoisted_16, _unref(DeviceState).screen.status === 'process' ? (_openBlock(), _createElementBlock("span", _hoisted_17, " 设备检测中... ")) : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(DeviceState).screen.txt), 1))])]), _createVNode(_component_a_button, {
        type: "primary",
        class: "next-step",
        onClick: _unref(onNextStep),
        loading: nextStepLoading.value
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref(JudgeCheckSuccess) ? '下一步' : '分享窗口'), 1)];
        }),
        _: 1
      }, 8, ["onClick", "loading"]), _unref(JudgeCheckError) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "no-check-entry",
        onClick: noAuthEntrance
      }, " 直接上传讲解视频 ")) : _createCommentVNode("", true)])]), _hoisted_19]);
    };
  }
});